import { render, staticRenderFns } from "./competitorsInfo.vue?vue&type=template&id=9d17ae9c&scoped=true"
import script from "./competitorsInfo.vue?vue&type=script&lang=js"
export * from "./competitorsInfo.vue?vue&type=script&lang=js"
import style0 from "./competitorsInfo.vue?vue&type=style&index=0&id=9d17ae9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d17ae9c",
  null
  
)

export default component.exports